<template>
  <div
    class="tariff-card"
    :class="{
      'tariff-card-tip': group.group_id.toString() === suggestedGroupId,
    }">
    <div class="promo-pills">
      <span class="promo-label" v-if="group.group_id.toString() === suggestedGroupId">💡 Náš tip</span>
      <a
        class="promo-label secondary"
        @click="$emit('promoLabelClicked', selectedProgram)"
        v-if="containsSaleLabel && checkForPromo()"
        v-html="promoLabel"></a>
    </div>
    <div class="tariff-card-header text-center">
      <h3>{{ includeIptv ? `IPTV + ${group.group_name}` : group.group_name }}</h3>
    </div>
    <div class="tariff-card-body">
      <ul class="package-list mb-3">
        <template v-if="includeIptv">
          <li class="d-flex align-items-start">
            <inline-svg :src="remoteSvg" class="svg-icon text-primary"></inline-svg>
            <div class="ml-2">
              <div>
                <strong>100+</strong> televizních stanic
                <VTooltip class="d-inline-block know-more-tooltip">
                  <span class="know-more">?</span>
                  <template #popper>
                    <span>IPTV můžete přes internet sledovat na chytré televizi, telefonu, tabletu či z webu.</span>
                  </template>
                </VTooltip>
              </div>
            </div>
          </li>
          <hr />
        </template>
        <li class="d-flex align-items-start package-minutes-row">
          <inline-svg :src="callSvg" class="svg-icon text-primary"></inline-svg>
          <div class="ml-2">
            <div class="package-minutes" v-if="containsInfiniteVoice">
              <strong>Neomezeně</strong>
              <span> minut </span>
            </div>
            <div class="package-minutes" v-if="selectedProgram?.incl_min > 0">
              <strong>{{ groupParams.incl_min }}</strong>
              <span> minut </span>
              <VTooltip class="d-inline-block know-more-tooltip">
                <span class="know-more">?</span>
                <template #popper>
                  <span>Po vyčerpání volných minut je cena za volání 1,50 Kč/min vč. DPH</span>
                </template>
              </VTooltip>
            </div>

            <div class="package-minutes" v-if="!containsInfiniteVoice && selectedProgram?.incl_min === 0">
              <strong> 1,50</strong>
              <span> Kč / min </span>
            </div>
            <div class="package-info" v-if="containsInfiniteVoiceInNetwork">+ neomezeně v síti PODA</div>
          </div>
        </li>
        <li class="d-flex">
          <inline-svg :src="messageSvg" class="svg-icon text-primary"></inline-svg>
          <div class="ml-2 package-sms" v-if="selectedProgram?.incl_sms > 0">
            <strong>{{ groupParams.incl_sms }}</strong> SMS
            <VTooltip class="d-inline-block know-more-tooltip">
              <span class="know-more">?</span>
              <template #popper>
                <span>Po vyčerpání volných SMS je cena za SMS 1,50 Kč vč. DPH.</span>
              </template>
            </VTooltip>
          </div>
          <div class="ml-2 package-sms" v-if="selectedProgram?.incl_sms === 0"><strong>1,50</strong> Kč / SMS</div>
        </li>
        <li class="d-flex align-items-start">
          <inline-svg :src="dataSvg" class="svg-icon text-primary"></inline-svg>

          <div class="package-data ml-2">
            <select
              class="form-select form-select-lg package-select"
              v-model="selectedProgram"
              @change="onSelectedProgram">
              <option v-for="program in getAvailablePrograms()" :value="program" :key="program.program_id">
                {{ program.data?.replace(".", ",") }}
              </option>
            </select>
            <ul
              class="mt-1 tariff-card-note"
              v-if="selectedProgram?.incl_data == 30000 || selectedProgram?.incl_data == 40000">
              <li class="text-primary">
                <template v-if="selectedProgram?.incl_data == 30000">10</template><template v-else>20</template> GB
                plnou rychlostí,
                <span class="text-gray-60">zbytek <span style="white-space: nowrap">2 Mb/s</span></span>
              </li>
            </ul>
            <div class="package-gift" v-if="dataGiftSize !== 0 && Date.now().valueOf < new Date('2023-04-01').valueOf">
              <strong>+ {{ dataGiftSize }} GB</strong> za 1 Kč
              <br />
              <button @click="$emit('giftLabelClicked')" class="package-gift-link">Bonusová data</button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="tariff-card-footer">
      <div class="package-price">
        <strong class="package-price-value client-price-calculated">
          {{ addIptvPriceIfNeeded(selectedProgram?.price_vat) }}
        </strong>
        Kč
        <span>měsíčně</span>
        <span class="text-muted text-sm"><br />(včetně DPH)</span>
      </div>
      <p class="package-before text-muted" v-if="showBottomCaption && isClient">
        <s>
          <span class="non-client-price-calculated" v-if="selectedProgram?.program_id !== 161">
            {{ addIptvPriceIfNeeded(alternativeProgram?.price_vat) }}</span
          >
          <span class="non-client-price-calculated" v-if="selectedProgram?.program_id === 161"> 460</span>
          Kč měsíčně
        </s>
      </p>
      <p class="package-before text-muted" v-if="showBottomCaption && !isClient">
        Nebo
        <span class="non-client-price-calculated"> {{ addIptvPriceIfNeeded(alternativeProgram?.price_vat) }}</span>
        Kč měsíčně
        <a @click="setIsClient(true)" class="non-client-link"> pro klienty PODA </a>
      </p>
      <button class="btn w-100 mb-2" @click="$emit('tariffChosen', selectedProgram)">
        <template v-if="includeIptv || !isClient">Mám zájem</template>
        <template v-else>Objednat</template>
      </button>
      <a
        class="tariff-card-more-info d-block text-center text-gray-60"
        @click="$emit('moreInfoClicked', selectedProgram)"
        >Více informací</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { SimTariffProgram } from "@/services/sim-tariffs/SimTariffProgram";
import InlineSvg from "vue-inline-svg";

import callSvg from "@/assets/img/sim/call.svg";
import messageSvg from "@/assets/img/sim/message.svg";
import dataSvg from "@/assets/img/sim/data.svg";
import arrowSvg from "@/assets/img/sim/arrow-right.svg";
import remoteSvg from "@/assets/img/sim/remote-control.svg";
import flatTvSvg from "@/assets/img/sim/flat-tv.svg";

export default defineComponent({
  props: {
    group: {
      type: Object,
    },
    isClient: {
      type: Boolean,
    },
    includeIptv: {
      type: Boolean,
      default: false,
      required: false,
    },
    iptvPrice: {
      type: Number,
      default: 0,
      required: false,
    },
    showBottomCaption: {
      type: Boolean,
      default: true,
      required: false,
    },
    promoCardId: {
      type: Number,
      default: 0,
      required: false,
    },
    promoLabel: {
      type: String,
      default: "",
      required: false,
    },
    promoFrom: {
      type: Date,
      required: false,
    },
    promoUntil: {
      type: Date,
      required: false,
    },
    defaultProgramsIds: {
      type: Object,
      required: true,
    },
  },
  emits: ["isClientChanged", "tariffChosen", "moreInfoClicked", "giftLabelClicked", "promoLabelClicked"],
  data() {
    return {
      suggestedGroupId: null,
      groupParams: {
        incl_min: null,
        incl_sms: null,
      },
      programs: [],
      selectedProgram: null,
      alternativeProgram: null,
      callSvg: callSvg,
      messageSvg: messageSvg,
      dataSvg: dataSvg,
      flatTvSvg: flatTvSvg,
      arrowSvg: arrowSvg,
      remoteSvg: remoteSvg,
    };
  },
  computed: {
    containsInfiniteVoice() {
      return this.group.group_id === 1;
    },
    containsInfiniteVoiceInNetwork() {
      return this.group.group_id === 4;
    },
    containsSaleLabel() {
      return this.group.group_id === this.promoCardId;
    },
    dataGiftSize() {
      const incl_data = this.selectedProgram?.incl_data ?? 0;
      const group_id = this.selectedProgram?.group_id ?? 0;

      if (group_id === 5) {
        return 0;
      }

      if (incl_data > 0 && incl_data <= 2000) {
        return 2;
      }
      if (incl_data > 2000 && incl_data < 8000) {
        return 4;
      }
      if (incl_data > 8000) {
        return 6;
      }
      return 0;
    },
  },
  mounted() {
    this.refreshPrograms();
    this.setDefaultOption();

    const search = new URLSearchParams(window.location.search);
    this.suggestedGroupId = search.get("group");
  },
  watch: {
    isClient: function () {
      this.setDefaultOption();
    },
  },
  components: {
    InlineSvg,
  },
  methods: {
    formatNumber(number: number, minimumFractionDigits: number, maximumFractionDigits: number) {
      return number.toLocaleString("cs-CZ", {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        useGrouping: true,
      });
    },
    async refreshPrograms() {
      this.programs = await this.$store.direct.getters.simTariffService.getPrograms(this.group.programs_id_all);
      // Extraxt phone and SMS params - should be same for all programs in the group
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      for (const [key, value] of Object.entries(this.programs)) {
        this.groupParams.incl_min = value.incl_min;
        this.groupParams.incl_sms = value.incl_sms;
      }
    },
    getAvailablePrograms() {
      const programIds = [] as SimTariffProgram[];
      const req_type = this.isClient ? "klient" : "neklient";
      const programs = this.group?.programs_id ?? [];
      const groupId = this.group?.group_id;
      const iptvDataPackages = this.defaultProgramsIds[groupId]?.iptv_data_packages;
      const shouldIncludeIptv = this.includeIptv && iptvDataPackages;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      for (const [_, program] of Object.entries(programs)) {
        const programId = program[req_type];

        if (shouldIncludeIptv) {
          if (iptvDataPackages.includes(programId.toString())) {
            programIds.push(programId);
          }
        } else {
          programIds.push(programId);
        }
      }

      if (this.programs instanceof Array) {
        const whitelistedPrograms = this.programs.filter((program: SimTariffProgram) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          return programIds.includes(program.program_id);
        });
        //   const whitelistedPrograms = Object.keys(this.programs).every((program: any) => {
        //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //     // @ts-ignore
        //     console.log(program);

        //     return programIds.includes(program.program_id)
        // });
        return whitelistedPrograms.sort((a, b) => {
          return a.incl_data - b.incl_data;
        });
      }

      return;
    },
    async onSelectedProgram() {
      // Lookup alternative price for clients
      for (const key in this.group.programs_id) {
        const program = this.group.programs_id[key];
        if (program.klient === this.selectedProgram.program_id) {
          this.alternativeProgram = await this.$store.direct.getters.simTariffService.getProgram(program.neklient);
          break;
        }
        if (program.neklient === this.selectedProgram.program_id) {
          this.alternativeProgram = await this.$store.direct.getters.simTariffService.getProgram(program.klient);
          break;
        }
      }
    },
    checkForPromo(): boolean {
      const currentDate = Date.now();

      if (this.promoFrom && this.promoUntil) {
        return currentDate >= this.promoFrom.getTime() && currentDate <= this.promoUntil.getTime();
      }

      return false;
    },
    async setDefaultOption() {
      let programId;

      if (
        this.checkForPromo() &&
        (this.defaultProgramsIds[this.group.group_id].id_client_promo ||
          this.defaultProgramsIds[this.group.group_id].id_nonclient_promo)
      ) {
        programId = this.isClient
          ? this.defaultProgramsIds[this.group.group_id].id_client_promo
          : this.defaultProgramsIds[this.group.group_id].id_nonclient_promo;
      } else {
        programId = this.isClient
          ? this.defaultProgramsIds[this.group.group_id].id_client
          : this.defaultProgramsIds[this.group.group_id].id_nonclient;
      }

      const program = await this.$store.direct.getters.simTariffService.getProgram(programId);
      if (program != undefined && program.group_id === this.group.group_id) {
        this.selectedProgram = program;
      }
      this.onSelectedProgram(); // Trigger to set alternative prog prices
    },
    async setIsClient(isClient: boolean) {
      this.$emit("isClientChanged", isClient);
    },
    addIptvPriceIfNeeded(price: number): number {
      if (!this.includeIptv) {
        return price;
      }
      return price + this.iptvPrice;
    },
    scrollToTVChannels() {
      const focusTarget = document.querySelector(".tv-channels-block");
      if (focusTarget) {
        focusTarget.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    },
  },
});
</script>
